// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NmD2Qq3gZ6E0xtrarTVy{flex-direction:column;width:260px;display:flex}.NmD2Qq3gZ6E0xtrarTVy .QuYJ1bxeD0ILspu46tqw{align-items:center;padding-left:5px;padding-right:5px}.NmD2Qq3gZ6E0xtrarTVy .QuYJ1bxeD0ILspu46tqw input{margin-left:4px}.djIsKy2WVqIVr31XlH_m{background-color:var(--border-neutral-default);width:100%;height:1px}.GRKF9O5wKeYDWJsPOYfs{padding:4px}.GRKF9O5wKeYDWJsPOYfs .GE5kXa5C120Stq02pPvv{max-height:160px;transition:max-height .3s ease-in-out;overflow-y:scroll}.GRKF9O5wKeYDWJsPOYfs .GE5kXa5C120Stq02pPvv::-webkit-scrollbar{width:5px;height:5px}.AcY1oZTmy9Uzi8bk2Oz2,.I3ju0X1jcjzS1iCveHMv{justify-content:center;align-items:center;height:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NmD2Qq3gZ6E0xtrarTVy`,
	"textInput": `QuYJ1bxeD0ILspu46tqw`,
	"divider": `djIsKy2WVqIVr31XlH_m`,
	"content": `GRKF9O5wKeYDWJsPOYfs`,
	"list": `GE5kXa5C120Stq02pPvv`,
	"loading": `AcY1oZTmy9Uzi8bk2Oz2`,
	"wrapEmpty": `I3ju0X1jcjzS1iCveHMv`
};
export default ___CSS_LOADER_EXPORT___;
